var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',{staticClass:"pa-0 ma-0",staticStyle:{"background-color":"var(--accent-color)"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }